import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Layout, Form, Button, Input, notification, Divider, Table } from 'antd'
import { graphql } from 'react-apollo'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import createProductMutation from '../graphql/mutations/createProduct'
import eventQuery from '../graphql/queries/event'

import '../css/form.css'

const { Content } = Layout
const FormItem = Form.Item

class RaceProduct extends Component {
  state = {
    submitting: false,
    code: null,
    shirts: [],
  }
  loadProduct = async (e) => {
    e.preventDefault()
    this.setState({ submitting: true })
    const slug = this.props.form.getFieldValue('slug')
    try {
      if (slug) {
        const { data: { event: { code, shirts } } } = await this.props.event.refetch({ slug })
        this.setState({ code, shirts })
      }
    } catch (err) {
      notification.error({
        message: 'Error',
        description: err.message,
      })
    } finally {
      this.setState({ submitting: false })
    }
  }
  importProduct = async () => {
    const { shirts } = this.state
    this.setState({ submitting: true })
    await shirts.asyncForEach(async (shirt) => {
      await this.props.createProduct({ variables: { record: shirt } })
    })
    this.setState({ submitting: false })
  }
  handleInputChange = (e) => {
    this.props.form.setFieldsValue({ [e.target.name]: e.target.value })
  }
  render() {
    const { getFieldDecorator } = this.props.form
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    }
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 4,
        },
      },
    }
    const columns = [
      {
        title: 'Group',
        dataIndex: 'group',
        key: 'group',
      },
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'Size',
        key: 'size',
        render: record => record.size || '-',
      },
      {
        title: 'Color',
        key: 'color',
        render: record => record.color || '-',
      },
      {
        title: 'ID',
        key: 'id',
        width: 280,
        render: record => (<span>Shop: {record.sku || '-'}<br />Race: {record.shirtId || '-'}</span>),
      },
    ]
    return (
      <Layout>
        <Navbar selected="product:5" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Form>
              <FormItem
                {...formItemLayout}
                label="Event slug"
              >
                {getFieldDecorator('slug', {
                  initialValue: '',
                  rules: [{ required: true, message: 'Please input event slug!' }],
                })(
                  <Input type="text" name="slug" onChange={this.handleInputChange} />
                )}
              </FormItem>
              <FormItem {...tailFormItemLayout}>
                <Button type="primary" style={{ marginRight: '10px' }} onClick={this.loadProduct} disabled={this.state.submitting}>Load product</Button>
                {this.state.code && (<Button type="primary" onClick={this.importProduct} disabled={this.state.submitting}>Import product</Button>)}
              </FormItem>
            </Form>
            <Divider />
            {this.state.shirts.length > 0 ? (
              <div>
                <h2>Preview (CODE: {this.state.code})</h2>
                <Table
                  rowKey="shirtId"
                  dataSource={this.state.shirts}
                  columns={columns}
                  pagination={{ pageSize: 50 }}
                  size="small"
                />
              </div>
            ) : null}
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
RaceProduct.propTypes = {
  form: PropTypes.shape(),
}
RaceProduct.defaultProps = {
  form: {},
}

export default graphql(createProductMutation, { name: 'createProduct' })(graphql(eventQuery, { name: 'event', options: { variables: { slug: '' } } })(Form.create()(RaceProduct)))



// WEBPACK FOOTER //
// ./src/pages/RaceProduct.js